<template>
  <div class="h-100 d-flex flex-column">
    <div class="row f-row justify-content-center">
      <div class="col col-1 mt-1">
        <button
          type="button"
          class="btn btn-strat-blue"
          style="margin: 0!important;"
          v-on:click="onUserShowFilters"
        >
          Close
        </button>
      </div>
    </div>
    <!-- https://www.primefaces.org/primevue/showcase-v2/#/datatable -->
    <div class="row f-row justify-content-center">
      <div
        class="mt-1 col col-12 text-center justify-content-center"
        style="width:100%!important; overflow-y:hidden;
        height: 500px!important;overflow-x:auto!important;"
      >
        <DataTable
          :alwaysShowPaginator="false"
          :filters.sync="dFilters"
          :lazy="false"
          :loading="showLoading"
          :paginator="true"
          :rows="0"
          :rowsPerPageOptions="[0, 15]"
          :selection.sync="selectedData"
          :value="dataVar"
          class="p-datatable-sm"
          filterDisplay="row"
          ref="dt"
          scrollHeight="400px"
          scrollDirection="horizontal"
          v-on:filter="onFilter"
        >
          <template #empty>
            No data found.
          </template>
          <template #loading>
            Loading data. Please wait.
          </template>

          <Column
            v-if="dDowns.portfoliosDDown.length > 0"
            header="Portfolio"
            filterField="portfolio"
            sortField="portfolio"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.portfolio }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.portfoliosDDown"
                placeholder="Select Portfolio"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.expoCodeDDown.length > 0"
            header="Exposure Id"
            filterField="custom_id"
            sortField="custom_id"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.custom_id }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.expoCodeDDown"
                placeholder="Select Exposure"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>
          <Column
            v-if="dDowns.commoditiesDDown.length > 0"
            header="Product"
            filterField="end_product_str"
            sortField="end_product_str"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.end_product_str }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.commoditiesDDown"
                placeholder="Select Commodities"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.countryDDown.length > 0"
            header="Country"
            filterField="country_of_destination"
            sortField="country_of_destination"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.country_of_destination }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.countryDDown"
                placeholder="Select Country"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.plantDDown.length > 0"
            header="Plant"
            filterField="plant_str"
            sortField="plant_str"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.plant_str }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.plantDDown"
                placeholder="Select Plant"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.businessDDown.length > 0"
            header="Business"
            filterField="business"
            sortField="business"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.business }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.businessDDown"
                placeholder="Select Business"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.supplierDDown.length > 0"
            header="Supplier"
            filterField="supplier"
            sortField="supplier"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.supplier }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.supplierDDown"
                placeholder="Select Supplier"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.clientDDown.length > 0"
            header="Client"
            filterField="client_str"
            sortField="client_str"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.client_str }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.clientDDown"
                placeholder="Select Client"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.counterPDDown.length > 0"
            header="Counterparty"
            filterField="counterparty"
            sortField="counterparty"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.counterparty }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.counterPDDown"
                placeholder="Select Counterparty"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.strategiesDDown.length > 0"
            header="Strategies"
            filterField="strategy_name"
            sortField="strategy_name"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.strategy_name }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.strategiesDDown"
                placeholder="Select Strategy"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.originDDown.length > 0"
            header="Origin"
            filterField="country_of_origin"
            sortField="country_of_origin"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.country_of_origin }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.originDDown"
                placeholder="Select Country"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.futuresDDown.length > 0"
            header="Futures"
            filterField="commodity"
            sortField="futures"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.futures }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.futuresDDown"
                placeholder="Select Commodities"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="dDowns.contractDDown.length > 0"
            header="Contract"
            filterField="contract_month_year"
            sortField="contract_month_year"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '5rem' }"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.contract_month_year }}
            </template>
            <template #filter="{filterModel, filterCallback}">
              <MultiSelect
                v-model="filterModel.value"
                :options="dDowns.contractDDown"
                placeholder="Select Contract"
                class="p-column-filter"
                scrollHeight="400px"
                @hide="filterCallback()"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <!--          <Column-->
          <!--            v-if="dDowns.expoTypeDDown.length > 0"-->
          <!--            header="Exposure Type"-->
          <!--            filterField="exposure_type"-->
          <!--            sortField="exposure_type"-->
          <!--            :showFilterMatchModes="false"-->
          <!--            :filterMenuStyle="{ width: '14rem' }"-->
          <!--            :styles="{ 'min-width': '9rem' }"-->
          <!--          >-->
          <!--            <template #body="{data}">-->
          <!--              {{ data.exposure_type }}-->
          <!--            </template>-->
          <!--            <template #filter="{filterModel, filterCallback}">-->
          <!--              <MultiSelect-->
          <!--                v-model="filterModel.value"-->
          <!--                :options="dDowns.expoTypeDDown"-->
          <!--                placeholder="Select Type"-->
          <!--                class="p-column-filter"-->
          <!--                scrollHeight="400px"-->
          <!--                @hide="filterCallback()"-->
          <!--              >-->
          <!--                <template #option="slotProps">-->
          <!--                  <div class="p-multiselect-representative-option">-->
          <!--                    <span class="image-text">{{ slotProps.option }}</span>-->
          <!--                  </div>-->
          <!--                </template>-->
          <!--              </MultiSelect>-->
          <!--            </template>-->
          <!--          </Column>-->
        </DataTable>
      </div>
    </div>
    <!-- Loading Modal -->
    <Messages :modal_message="modal_processing_message" />
    <Messages :modal_message="modal_process_finished_message" />
  </div>
</template>

<script>
import { Company } from "@/_core/data/Company";
import { defineDDowns, defineFilters } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Messages from "../modals/Messages.vue";
import MultiSelect from "primevue/multiselect";

export default {
  name: "CommodityFilters",
  components: {
    Column,
    DataTable,
    Messages,
    MultiSelect
  },
  props: {
    dataFilters: {
      required: true,
      default() {
        return defineFilters();
      }
    },
    dataVar: { required: true },
    dDowns: { required: true, default: defineDDowns() },
    showLoading: { required: true }
  },
  data() {
    return {
      companies: [],
      dataToExport: [],
      selection: "com_expo",
      dFilters: defineFilters(),
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false
      },
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false
      },
      selectedData: null,
      sheetTransaction: null,
      showFilters: true,
      showAllFields: false,
      showMore: "+ Fields",
      user: []
    };
  },
  computed: {},
  watch: {
    dataFilters(fltr) {
      Object.assign(this, {
        dFilters: fltr
      });
    },
    dFilters(fltr) {
      this.$emit("eventOnUserFilter", fltr);
    }
  },
  created() {
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.error(`Error user ${error}`);
    }
    try {
      this.companies = this.$store.state.companies.all.items;
      this.companyLen = this.companies.length;
    } catch (error) {
      console.error(`Error companies ${error}`);
    }
    try {
      this.processed_company = new Company(this);
    } catch (error) {
      console.error(`Error companies loader ${error}`);
    }
  },
  mounted() {
    this.dFilters = this.dataFilters;
  },
  methods: {
    onFilter(event) {
      this.$emit("eventOnFilteredData", event.filteredValue);
    },
    onUserShowFilters() {
      this.$emit("eventOnUserShowFilters", false);
    }
  }
};
</script>
